export default "__VITE_ASSET__258e2de3__"